export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "918828271040";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "info@zolvix.in";

export const DEFAULT_WHATSAPP_MESSAGE =
  "Hello Zolvix Team, I would like to discuss a software development project.";

export function whatsappUrl(message = DEFAULT_WHATSAPP_MESSAGE) {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
}

export function mailtoUrl(subject = "Enquiry — Zolvix Technologies", body = "") {
  const qs = new URLSearchParams({ subject, body }).toString();
  return `mailto:${CONTACT_EMAIL}?${qs}`;
}
